import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type DividendContentProps = {
  configData: ConstraintConfigType;
};

export function DividendContent({ configData }: DividendContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="dividend"
    />
  );
}
